import sponsorsAPI from "../api/sponsorsAPI";

const state = {
  booth: {
    additionalDates: [],
    conference: {
      event_logo: '',
      event_logo_url: '',
      name: '',
    },
    sponsor: {
      address: {
        address: '',
        city: '',
        state: {},
        zip: '',
        phone: ''
      },
      company_email: '',
      company_website: '',
      giveaways: []
    },
    setting: {
      facebook_link: '',
      linkedin_link: '',
      twitter_link: '',
      youtube_link: ''
    },
    hasMaterials: false,
    isAttendee: false
  },
  isFetching: false,
  hasFetchedBooth: false,
};

const actions = {
  async fetchBoothInfo({commit}, {attendeeId, sponsorId}) {
    commit("updateIsFetching", true);

    try {
      const response = await sponsorsAPI.fetchBoothInfo(attendeeId, sponsorId);
      commit("updateBooth", response.data?.data);
    } catch (error) {
      console.error('Failed to fetch notification:', error);
    } finally {
      commit("updateIsFetching", false);
    }
  },

  fetchExhibitorMaterials({ state, dispatch }, {attendeeId}) {
    return new Promise(resolve => {
      sponsorsAPI.fetchExhibitorMaterials(attendeeId, state.booth?.sponsor?.id)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(() => {
          resolve({
            categories: [],
            materials: []
          })
        });
    });
  },

  sendInfoToExhibitor({ state, dispatch }, { attendeeId, data }) {
    return new Promise(resolve => {
      sponsorsAPI.sendInfoToExhibitor(attendeeId, state.booth.sponsor?.id, data)
        .then(({ status }) => {
          resolve(status);
        })
        .catch(({ response }) => {
          // TODO: add errors if need in the future
          // const errorMessage = response.data && response.data.flash ? response.data.flash : ''
          // dispatch(`snackbar/${SHOW_ERROR_SNACKBAR}`, errorMessage)
          resolve(response.status);
        });
    });
  },

  enterToGiveAway({ state, dispatch }, { attendeeId, data }) {
    return new Promise(resolve => {
      sponsorsAPI.enterToGiveAway(attendeeId, state.booth.sponsor.id, data)
        .then(({ status }) => {
          // dispatch(`snackbar/${SHOW_SUCCESS_SNACKBAR}`, i18n.t('SUCCESS_REGISTERED_TO_GIVEAWAY_MESSAGE'))
          resolve(status);
        })
        .catch(({ response }) => {
          // TODO: add errors if need in the future
          // const errorMessage = response.data && response.data.flash ? response.data.flash : ''
          // dispatch(`snackbar/${SHOW_ERROR_SNACKBAR}`, errorMessage)
          resolve(response.status);
        });
    });
  }
};

const mutations = {
  updateBooth(state, payload) {
    const {
      conference,
      hasMaterials,
      isAttendee,
      setting,
      sponsor,
      pathname,
      redirectBackUrl
    } = payload;

    let { additionalDates } = payload

    if (!sponsor.address) {
      sponsor.address = {
        city: '',
        state: null,
        phone: '',
        zip: ''
      };
    }

    if (sponsor.giveaways && sponsor.giveaways.length) {
      sponsor.giveaways.forEach(el => {
        el.loading = false
      });
    }

    additionalDates = Object.values(additionalDates);

    state.booth = {
      additionalDates,
      conference,
      hasMaterials,
      isAttendee,
      setting,
      sponsor,
      pathname,
      redirectBackUrl
    };

    state.hasFetchedBooth = true;
  },

  //TODO: check if it's work, maybe do it using SET
  updateGiveaways(state, value) {
    state.booth.sponsor.giveaways = value;
  },

  updateIsFetching(state, isFetching) {
    state.isFetching = isFetching;
  },
};

const getters = {
  booth(state) {
    return state.booth
  },

  sponsor(state) {
    return state.booth.sponsor
  },

  email(state) {
    return state.booth.sponsor.company_email
  },

  website(state) {
    return state.booth.sponsor.company_website
  },

  phone(state) {
    return state.booth.sponsor.address.phone
  },

  giveaways(state) {
    return state.booth.sponsor.giveaways
  },

  isAttendee(state) {
    return state.booth.isAttendee
  },

  hasMaterials(state) {
    return state.booth.hasMaterials
  },

  isFetching(state) {
    return state.isFetching;
  },

  boothRepresentatives(state) {
    return state.booth.sponsor.booth_presenters || []
  },

  additionalDates(state) {
    let meetings = []
    if (state.booth.additionalDates && state.booth.additionalDates.length) {
      meetings = state.booth.additionalDates.filter(elem => {
        return elem.forward_meeting_url
      })

      return meetings
    } else {
      return []
    }
  },

  eventName(state) {
    return state.booth.conference.name
  },

  hasFetchedBooth(state) {
    return state.hasFetchedBooth;
  },

  //TODO: check if it's needed
  fullAddress(state) {
    let fullAddress = ''

    const address = state.booth.sponsor.address

    if (address.address) {
      fullAddress = address.address
    }
    if (address.city) {
      fullAddress += `, ${address.city}`
    }
    if (address.state && address.state.code) {
      fullAddress += `, ${address.state.code}`
    }
    if (address.zip) {
      fullAddress += ` ${address.zip}`
    }

    return fullAddress
  },

  isFullRegisteredToGiveaways(state) {
    let count = 0
    const giveawaysLength = state.booth.sponsor.giveaways.length
    state.booth.sponsor.giveaways.forEach(el => {
      if (el.is_registered) {
        count++
      }
    })

    return giveawaysLength === count
  },

  hasSocials(state) {
    const socials = state.booth.setting

    return !!(state.booth.setting.facebook_link || socials.linkedin_link || socials.twitter_link || socials.youtube_link)
  },

  facebookLink(state) {
    return state.booth.setting.facebook_link
  },

  linkedInLink(state) {
    return state.booth.setting.linkedin_link
  },

  twitterLink(state) {
    return state.booth.setting.twitter_link
  },

  youtubeLink(state) {
    return state.booth.setting.youtube_link
  },

  exhibitDescription(state) {
    return state.booth.sponsor.description
  },

  eventLogo(state) {
    return state.booth.conference.event_logo_url
  },

  exhibitLogo(state) {
    return state.booth.sponsor.photo_url
  },

  exhibitHallPageUrl(state) {
    return state.booth.exhibit_hall_page_url
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
